import BudgetExpensePage from '@/common/pages/(private)/(dashboard)/budgets/[budgetId]/budget_employees/[budgetEmployeeId]/expenses/[expenseId]';

export default function Page() {
  return <BudgetExpensePage />;
}
